import { Control } from '@/gen/inventory/v1/control_service_pb'

import { sortByLocale } from '@/lib/collection/array-utils'

/**
 * Filters controls to only enabled ones and sorts them by title alphabetically.
 *
 * @param controls - Array of controls (can be null/undefined)
 * @returns Array of enabled controls sorted by title, or empty array if controls is null/undefined
 */
export function filterAndSortActiveControls(controls: Control[] | null | undefined): Control[] {
  if (!controls) {
    return []
  }

  const activeControls = controls.filter(({ isEnabled }) => isEnabled)
  return sortByLocale(activeControls, 'title')
}
